import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useSession } from '@ghq-abi/auth-client-lib/client';
import mixpanel from 'mixpanel-browser';

import { useUser } from '~/app/contexts/UserContext';

import { initMixpanel } from '../../../mixpanelClient';

export function useInitMixPanel() {
  const router = useRouter();
  const { data } = useSession();
  const user = useUser();

  useEffect(() => {
    initMixpanel();

    try {
      if (data && process.env.NEXT_PUBLIC_MIXPANEL_TOKEN) {
        const { user: session } = data;

        mixpanel.identify(session.globalId);
        mixpanel.people.set({
          $name: session.name,
          $email: session?.email,
          globalId: session.globalId,
          zone: session?.zone,
          band: session?.band,
          country: session.country,
          isManager: user.originalUser.roles?.isManager,
          isSuperAdmin: user.originalUser.roles?.isSuperAdmin,
          isGlobalAdmin: user.originalUser.roles?.isGlobalAdmin,
          isZoneAdmin: user.originalUser.roles?.isZoneAdmin,
          isPBP: user.originalUser.roles?.isPBP,
          isTalentManager: user.originalUser.roles?.isTalentManager,
          isProxied: user?.isProxied,
          userProxied: user?.isProxied
            ? {
                name: user?.name,
                globalId: user?.globalId,
              }
            : null,
        });
      }
    } catch (err) {
      console.error('Failed to init mixpanel');
    }
  }, [data, user, router.events]);
}
